// Translation dictionaries keyed by the exact English string. Rows live in messages-*.ts as
// [English, Hindi, Arabic, Spanish]; split only to keep files reviewable.
import m1 from './messages-1';
import m2 from './messages-2';
import m3 from './messages-3';
import m4 from './messages-4';

export const MESSAGES: [string, string, string, string][] = [...m1, ...m2, ...m3, ...m4];

function build(col: 1 | 2 | 3): Record<string, string> {
  const out: Record<string, string> = {};
  for (const row of MESSAGES) out[row[0]] = row[col];
  return out;
}

export const DICTS = { hi: build(1), ar: build(2), es: build(3) };
